export { default, ScoreProcessingCard } from './ScoreProcessingCard';
export * from './ScoreProcessingCard.types';
